import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from "redux";
import { PeopleItem } from '../../shared';

class OurTeam extends React.Component<any, any> {

    constructor(props, context) {
        super(props, context);
    }
    componentDidMount() {
        window.scrollTo(0, 0);
    }
    render() {
        if (!this.props.aboutPeople || this.props.isLoading) {
            return (<div></div>);
        }

        let items = this.props.aboutPeople.filter(f => f.categoryId == 1).map((item, index) => {
             return <PeopleItem key={"people1Item" + index} {...item}></PeopleItem>; 
            });

        return (<section className="base3-bg">

            <div className="container pt-2  mb-4">
                    <h1>Our Team</h1>
                </div>
            {items}
            </section>);
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        aboutPeople: state.siteData.siteData.aboutPeople,
        isLoading: state.siteData.isLoading
    };
}

const mapDispatchToProps = dispatch => {
    return bindActionCreators(
        { },
        dispatch
    );
};


const OurTeamContainer = connect(mapStateToProps, mapDispatchToProps)(
    OurTeam
);

export default OurTeamContainer;


// WEBPACK FOOTER //
// ./src/components/People/OurTeam.tsx